export interface AppFileUploadModel {
  applicationId: number;
  agencyId: number;
  fileList: FileModel[];
  errorFound?: boolean;
  errorMessage?: string;
}

export interface FileModel {
  questionIdentifier: string;
  fileName: string;
  fileSize?: number;
  checkSum?: string;
  /** @deprecated - use filePath instead */
  targetURL?: string;
  filePath?: string;
  identifier?: string;
  errorFound?: boolean;
  errorMessage?: string;
  totalBytes?: number;
  uploadedBytes?: number;
  percentComplete?: number;
  status?: FileUploadStatus;
}

export interface UploadedFileModel {
  questionIdentifier: string;
  identifier: string;
  fileName: string;
  fileSize: number;
  status: FileUploadStatus;
}

export interface ErrorResponse {
  errorFound: boolean;
  publicMessage: string;
}

export enum FileUploadStatus {
  Uploading = 'uploading',
  Confirming = 'confirming',
  Complete = 'complete',
  Error = 'error',
}
